import { useEffect, useRef } from 'react';

// Recharge `fn` périodiquement et au retour de focus sur l'onglet — les
// listes (commandes, missions) restent à jour après un ajout, une
// annulation ou une modification faite depuis un autre écran ou acteur.
export default function useAutoReload(fn, intervalMs = 30000) {
  const ref = useRef(fn);
  ref.current = fn;

  useEffect(() => {
    const tick = () => ref.current();
    const onFocus = () => ref.current();
    const onVisible = () => { if (!document.hidden) ref.current(); };
    const id = setInterval(tick, intervalMs);
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);
}
